/* eslint-disable no-console */
// Zentrale Logging-Util. Kapselt console, damit Call-Sites kein no-console
// disable brauchen und wir das Logging später an einen Sink hängen können.

export const logger = {
  debug: (...args: unknown[]): void => console.debug(...args),
  info: (...args: unknown[]): void => console.info(...args),
  warn: (...args: unknown[]): void => console.warn(...args),
  error: (...args: unknown[]): void => console.error(...args),
};
